import { useEffect, useState } from "react";

const CAPTIONS = [
  ["Roll. Crush. Escape.", "Help Rocco the pup get out of the cavern"],
  ["Push the spheres", "Crush scorpions, spiders, snakes & bats"],
  ["Combo!", "Hit two with one sphere"],
  ["Merge the bones", "Unleash Rocco's POWER"],
  ["50 hand-made levels", "Six cavern worlds · secret tunnels"],
  ["Daily challenge", "Same level for everyone · online leaderboards"],
  ["Play with friends", "Make a pack · compare scores"],
  ["Play free now", "rollpuproll.com"],
];
const STEP_MS = 3500;

export const TrailerSoundHint = () => (
  <div data-testid="trailer-sound-hint" className="trailer-sound-hint">Tap anywhere to turn on sound</div>
);

export const TrailerCaptions = () => {
  const [i, setI] = useState(0);
  useEffect(() => { const id = setInterval(() => setI((v) => (v + 1) % CAPTIONS.length), STEP_MS); return () => clearInterval(id); }, []);
  const [title, sub] = CAPTIONS[i];
  return (
    <div data-testid="trailer-captions" className="trailer-captions" key={i}>
      <div className="trailer-title">{title}</div>
      <div className="trailer-sub">{sub}</div>
    </div>
  );
};
